import React, { useEffect } from "react";
import useApiFetch from "./utils/api";
import { API_URL } from "./utils/constant";

export default function Sidebar({ mapRef }) {
  const {
    res: restData,
    load: loadData,
    loading: loadingData,
  } = useApiFetch("GET", API_URL + "/adherent");

  useEffect(() => {
    loadData();
  }, []);

  const handleClick = (item) => {
    let map = mapRef.current;
    map.flyTo([item.latitude, item.longitude], 6);

    //TODO: je pense que même si j'ai pas le fonctionnement dans le trello, ni sur le devis, ni nul pars, je vais quand même avoir en retour qu'il faut ouvrir la popup au click sur un adhérent dans la sidebar
  };

  return (
    <div className="container">
      <div className="leaflet-sidebar">
        <h2>Nos adhérents</h2>

        <div className="leaflet-sidebar_list">
          {restData?.posts.map((item, key) => {
            return (
              <div
                className="leaflet-sidebar_list_item"
                key={item.id}
                onClick={() => handleClick(item)}
              >
                <span>{key + 1}</span>
                <img src={item.image} alt={item.post_title} />
                <h3>{item.post_title}</h3>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
